/**
 * A signed-in page with the screen to itself — the packet editor.
 * @file src/web/shared/FocusLayoutRoute.tsx
 *
 * Placing fields on an eighteen-page agreement needs the width the sidebar
 * takes, the way DocuSign's prepare view drops its navigation. The guards
 * are the dashboard's own (signed in, a firm account), so leaving the
 * sidebar out never means leaving the AuthGuard out — the mistake
 * layout.intake.tsx warns about.
 */
import { Outlet } from 'react-router-dom';
import { AuthGuard } from '@/features/auth/components';
import { FirmOnly } from './DashboardLayoutRoute';

export function FocusLayoutRoute() {
  return (
    <AuthGuard>
      <FirmOnly>
        <div className="min-h-[100dvh] bg-background">
          <Outlet />
        </div>
      </FirmOnly>
    </AuthGuard>
  );
}
